import { render, staticRenderFns } from "./PershingConsolidatedStatement.vue?vue&type=template&id=3edbc39e&scoped=true"
import script from "./PershingConsolidatedStatement.vue?vue&type=script&lang=js"
export * from "./PershingConsolidatedStatement.vue?vue&type=script&lang=js"
import style0 from "./PershingConsolidatedStatement.vue?vue&type=style&index=0&id=3edbc39e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edbc39e",
  null
  
)

export default component.exports